import { styled } from '@mui/material';

export const CampaignInfoCardsContainer = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
  flex: 1,
  marginBottom: '1.5rem',
}));
